/**
 * Purpose: exclusive fallback delays. Split out so exclusiveFallbackUI stays under baseline.
 * Boundaries: timing helpers only. Sleep never rejects.
 */
export const DEVICE_BUSY_RETRY_MS = 750;
export const isExclusiveOpenTimeoutError = (errMsg: string): boolean => /command timeout|ipc invoke timeout|exclusive_open_timeout:/i.test(String(errMsg || '')); // #10426-a1
export const SHARED_FALLBACK_RELEASE_MS = 500;

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
